export default [
  {
    path: "/labor/attendance-statistics/list",
    name: "labor-attendance-statistics",
    meta: { title: "考勤统计" },
    component: () =>
      import(/* webpackChunkName: "join" */ "@/views/labor/attendance-statistics/index.vue"),
  },
];
